"use strict";

const Accordions = () => {
    const init = () => {
        $(function() {
            window.refreshAccordions = function(){
                var $accordions = $('.js-accordion');
                
                $accordions.children('.js-accordion-title').off('click');
                $accordions.children('.js-accordion-title').on('click', function(){
                    var $parent = $(this).parent('.js-accordion');
                    if($parent.hasClass('active')){
                        $parent.removeClass('active');
                        $parent.children('.js-accordion-content').slideUp();
                        if($parent.data('label') !== undefined){
                            $parent.children('.js-accordion-title').text($parent.data('label'));
                        }
                    }else{
                        if($parent.data('exclusive') !== undefined){
                            $accordions.filter('.active').children('.js-accordion-content').slideUp();
                            $accordions.removeClass('active');
                            $parent.addClass('active');
                            $parent.children('.js-accordion-content').slideDown();
                        }else{
                            $parent.addClass('active');
                            $parent.children('.js-accordion-content').slideDown();
                            if($parent.data('label') !== undefined){
                                $parent.children('.js-accordion-title').text($parent.data('active-label'));
                            }
                        }
                    }

                    if ($(this).hasClass('inclusion-accordion')) {
                        let refresher = setInterval(() => {
                            window.Select.refreshInclusionSelect()
                        }, 10);

                        setTimeout(() => {
                            clearInterval(refresher)
                        }, 400)
                    }
                });
                
                $accordions.filter('[data-index="1"]').children('.js-accordion-title').trigger('click');
            }

            refreshAccordions();
        });
    };

    return {
        init:init
    };
};

export default Accordions;